import {REDUCER_NAME as PARENT_REDUCER_NAME} from '../const'
import {REDUCER_NAME} from './const'

const NS = PARENT_REDUCER_NAME + '/' + REDUCER_NAME + '/'

export const CHANGE_ACTIVE_TAB = NS + 'CHANGE_ACTIVE_TAB'

export const FIND_CUSTOMER_PARTIAL_REQUEST = NS + 'FIND_CUSTOMER_PARTIAL_REQUEST'

export const FIND_CUSTOMER_REQUEST = NS + 'FIND_CUSTOMER_REQUEST'
export const FIND_CUSTOMER_SUCCESS = NS + 'FIND_CUSTOMER_SUCCESS'
export const FIND_CUSTOMER_ERROR = NS + 'FIND_CUSTOMER_ERROR'

export const HYDRATE_CUSTOMER_CONTACT = NS + 'HYDRATE_CUSTOMER_CONTACT'

export const START_REFINEMENT_SHOP_PROCESS_REQUEST = NS + 'START_REFINEMENT_SHOP_PROCESS_REQUEST'
export const START_REFINEMENT_SHOP_PROCESS_SUCCESS = NS + 'START_REFINEMENT_SHOP_PROCESS_SUCCESS'
export const START_REFINEMENT_SHOP_PROCESS_ERROR = NS + 'START_REFINEMENT_SHOP_PROCESS_ERROR'

export const START_RETAINER_REFINEMENT_PROCESS_REQUEST = NS + 'START_RETAINER_REFINEMENT_PROCESS_REQUEST'
export const START_RETAINER_REFINEMENT_PROCESS_SUCCESS = NS + 'START_RETAINER_REFINEMENT_PROCESS_SUCCESS'
export const START_RETAINER_REFINEMENT_PROCESS_ERROR = NS + 'START_RETAINER_REFINEMENT_PROCESS_ERROR'

export const START_REFINEMENT_SET_PROCESS_REQUEST = NS + 'START_REFINEMENT_SET_PROCESS_REQUEST'
export const START_REFINEMENT_SET_PROCESS_SUCCESS = NS + 'START_REFINEMENT_SET_PROCESS_SUCCESS'
export const START_REFINEMENT_SET_PROCESS_ERROR = NS + 'START_REFINEMENT_SET_PROCESS_ERROR'

export const START_ESCALATION_PROCESS_REQUEST = NS + 'START_ESCALATION_PROCESS_REQUEST'
export const START_ESCALATION_PROCESS_SUCCESS = NS + 'START_ESCALATION_PROCESS_SUCCESS'
export const START_ESCALATION_PROCESS_ERROR = NS + 'START_ESCALATION_PROCESS_ERROR'

export const START_ALIGNER_REPRODUCTION_PROCESS_REQUEST = NS + 'START_ALIGNER_REPRODUCTION_PROCESS_REQUEST'
export const START_ALIGNER_REPRODUCTION_PROCESS_SUCCESS = NS + 'START_ALIGNER_REPRODUCTION_PROCESS_SUCCESS'
export const START_ALIGNER_REPRODUCTION_PROCESS_ERROR = NS + 'START_ALIGNER_REPRODUCTION_PROCESS_ERROR'

export const START_PARTIAL_REFUND_PROCESS_REQUEST = NS + 'START_PARTIAL_REFUND_PROCESS_REQUEST'
export const START_PARTIAL_REFUND_PROCESS_SUCCESS = NS + 'START_PARTIAL_REFUND_PROCESS_SUCCESS'
export const START_PARTIAL_REFUND_PROCESS_ERROR = NS + 'START_PARTIAL_REFUND_PROCESS_ERROR'

export const START_DOWNLOAD_CUSTOMER_DATA_REQUEST = NS + 'START_DOWNLOAD_CUSTOMER_DATA_REQUEST'
export const START_DOWNLOAD_CUSTOMER_DATA_SUCCESS = NS + 'START_DOWNLOAD_CUSTOMER_DATA_SUCCESS'
export const START_DOWNLOAD_CUSTOMER_DATA_ERROR = NS + 'START_DOWNLOAD_CUSTOMER_DATA_ERROR'


export const CHANGE_CUSTOMER = NS + 'CHANGE_CUSTOMER'

export const CHANGE_CUSTOMER_CONTACT = NS + 'CHANGE_CUSTOMER_CONTACT'

export const SAVE_CUSTOMER_REQUEST = NS + 'SAVE_CUSTOMER_REQUEST'
export const SAVE_CUSTOMER_SUCCESS = NS + 'SAVE_CUSTOMER_SUCCESS'
export const SAVE_CUSTOMER_ERROR = NS + 'SAVE_CUSTOMER_ERROR'

export const UPLOAD_CUSTOMER_IMAGE_REQUEST = NS + 'UPLOAD_CUSTOMER_IMAGE_REQUEST'
export const UPLOAD_CUSTOMER_IMAGE_SUCCESS = NS + 'UPLOAD_CUSTOMER_IMAGE_SUCCESS'
export const UPLOAD_CUSTOMER_IMAGE_ERROR = NS + 'UPLOAD_CUSTOMER_IMAGE_ERROR'

export const ROTATE_CUSTOMER_IMAGE_REQUEST = NS + 'ROTATE_CUSTOMER_IMAGE_REQUEST'
export const ROTATE_CUSTOMER_IMAGE_SUCCESS = NS + 'ROTATE_CUSTOMER_IMAGE_SUCCESS'
export const ROTATE_CUSTOMER_IMAGE_ERROR = NS + 'ROTATE_CUSTOMER_IMAGE_ERROR'

export const TOGGLE_IMAGE_VIEW = NS + 'TOGGLE_IMAGE_VIEW'

export const ADD_CUSTOMER_FILE = NS + 'ADD_CUSTOMER_FILE'
export const SET_FILE_DELETE_FLAG = NS + 'SET_FILE_DELETE_FLAG'

export const FIX_ACCOUNT_PROBLEM_REQUEST = NS + 'FIX_ACCOUNT_PROBLEM_REQUEST'
export const FIX_ACCOUNT_PROBLEM_SUCCESS = NS + 'FIX_ACCOUNT_PROBLEM_SUCCESS'
export const FIX_ACCOUNT_PROBLEM_ERROR = NS + 'FIX_ACCOUNT_PROBLEM_ERROR'

export const OPEN_CHANGE_EMAIL_MODAL = NS + 'OPEN_CHANGE_EMAIL_MODAL'
export const CLOSE_CHANGE_EMAIL_MODAL = NS + 'CLOSE_CHANGE_EMAIL_MODAL'

export const OPEN_RESPONSE_FEEDBACK_MODAL = NS + 'OPEN_RESPONSE_FEEDBACK_MODAL'
export const CLOSE_RESPONSE_FEEDBACK_MODAL = NS + 'CLOSE_RESPONSE_FEEDBACK_MODAL'

export const HANDLE_DELETE_CONFIRMATION_MODAL = NS + 'HANDLE_DELETE_CONFIRMATION_MODAL'
export const SHOW_ERROR_CONFIRMATION_MODAL = NS + 'SHOW_ERROR_CONFIRMATION_MODAL'

export const OPEN_DELETE_CONFIRMATION_MODAL = NS + 'OPEN_DELETE_CONFIRMATION_MODAL'
export const CLOSE_DELETE_CONFIRMATION_MODAL = NS + 'CLOSE_DELETE_CONFIRMATION_MODAL'

export const DELETE_CUSTOMER_REQUEST = NS + 'DELETE_CUSTOMER_REQUEST'
export const DELETE_CUSTOMER_SUCCESS = NS + 'DELETE_CUSTOMER_SUCCESS'
export const DELETE_CUSTOMER_ERROR = NS + 'DELETE_CUSTOMER_ERROR'

export const CHANGE_NEW_EMAIL = NS + 'CHANGE_NEW_EMAIL'

export const CHANGE_EMAIL_REQUEST = NS + 'CHANGE_EMAIL_REQUEST'
export const CHANGE_EMAIL_SUCCESS = NS + 'CHANGE_EMAIL_SUCCESS'
export const CHANGE_EMAIL_ERROR = NS + 'CHANGE_EMAIL_ERROR'

export const FIND_PROCESS_COMMENT_REQUEST = NS + 'FIND_PROCESS_COMMENT_REQUEST'
export const FIND_PROCESS_COMMENT_SUCCESS = NS + 'FIND_PROCESS_COMMENT_SUCCESS'
export const FIND_PROCESS_COMMENT_ERROR = NS + 'FIND_PROCESS_COMMENT_ERROR'

export const SAVE_TREATMENT_EXECUTION_CLARIFICATION_COMMENT_REQUEST = NS + 'SAVE_TREATMENT_EXECUTION_CLARIFICATION_COMMENT_REQUEST'
export const SAVE_TREATMENT_EXECUTION_CLARIFICATION_COMMENT_SUCCESS = NS + 'SAVE_TREATMENT_EXECUTION_CLARIFICATION_COMMENT_SUCCESS'
export const SAVE_TREATMENT_EXECUTION_CLARIFICATION_COMMENT_ERROR = NS + 'SAVE_TREATMENT_EXECUTION_CLARIFICATION_COMMENT_ERROR'

export const UPDATE_WHATSAPP_OPT_IN_REQUEST = NS + 'UPDATE_WHATSAPP_OPT_IN_REQUEST'
export const UPDATE_WHATSAPP_OPT_IN_SUCCESS = NS + 'UPDATE_WHATSAPP_OPT_IN_SUCCESS'
export const UPDATE_WHATSAPP_OPT_IN_ERROR = NS + 'UPDATE_WHATSAPP_OPT_IN_ERROR'
export const UPDATE_WHATSAPP_OPT_IN_NON_VALID_VALUE = NS + 'UPDATE_WHATSAPP_OPT_IN_NON_VALID_VALUE'

export const UPDATE_IS_TRANSFERRED_TO_DR_SMILE_REQUEST = NS + 'UPDATE_IS_TRANSFERRED_TO_DR_SMILE_REQUEST'
export const UPDATE_IS_TRANSFERRED_TO_DR_SMILE_SUCCESS = NS + 'UPDATE_IS_TRANSFERRED_TO_DR_SMILE_SUCCESS'
export const UPDATE_IS_TRANSFERRED_TO_DR_SMILE_ERROR = NS + 'UPDATE_IS_TRANSFERRED_TO_DR_SMILE_ERROR'



// WEBPACK FOOTER //
// ./src/modules/customer/state/detail/type.js